import {createSlice} from '@reduxjs/toolkit';
import {getCookie} from '../../utils/helpers/cookie';

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    asideCollapsed: getCookie('collapsed') === 'true',
    asideShow: getCookie('collapsed') !== 'true',
    open: false,
  },
  reducers: {
    setAsideCollapsed: (state, {payload}) => ({
      ...state,
      asideCollapsed: payload,
    }),
    setAsideShow: (state, {payload}) => ({
      ...state,
      asideShow: payload,
    }),
    setOpen: (state, {payload}) => ({
      ...state,
      open: payload,
    }),
  },
});

export const navigationState = state => state.navigation;

export const {setAsideCollapsed, setAsideShow, setOpen} =
  navigationSlice.actions;

export default navigationSlice.reducer;
